import { DocumentType } from 'core/types/document';

export const isFolderDocument = (type: string): boolean => type === DocumentType.FOLDER